module.exports = __webpack_public_path__ + "img/kjsy_gallery7.35f89151.jpg";